import { render, staticRenderFns } from "./NoAccountMessage.vue?vue&type=template&id=6ed635d0&scoped=true"
import script from "./NoAccountMessage.vue?vue&type=script&lang=ts"
export * from "./NoAccountMessage.vue?vue&type=script&lang=ts"
import style0 from "./NoAccountMessage.vue?vue&type=style&index=0&id=6ed635d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed635d0",
  null
  
)

export default component.exports